import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wordpress': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M61.7 169.4l101.5 278c-71-34.4-119.9-107.2-119.9-191.4 0-30.9 6.6-60.1 18.4-86.6zM399.6 245.3c0 18.2-7 39.3-16 68.7l-21.2 70.9-76.9-228.7c12.8-0.7 24.3-2 24.3-2 11.4-1.3 10.1-18.2-1.4-17.5 0 0-34.5 2.7-56.7 2.7-20.9 0-56-2.7-56-2.7-11.4-0.7-12.8 16.8-1.3 17.5 0 0 10.8 1.3 22.3 2l33.1 90.8-46.6 139.6-77.5-230.4c12.8-0.7 24.3-2 24.3-2 11.4-1.3 10.1-18.2-1.4-17.5 0 0-34.5 2.7-56.7 2.7-4 0-8.7-0.1-13.7-0.3 38.1-57.8 103.5-95.9 177.8-95.9 55.4 0 105.8 21.2 143.7 55.9-1-0.1-1.9-0.2-2.8-0.2-20.9 0-35.7 18.2-35.7 37.8 0 17.5 10.1 32.4 20.9 49.9 8.1 14.2 17.5 32.4 17.5 58.7zM259.7 274.6l65.4 179.2c0.4 1 0.9 2 1.5 2.9-22.1 7.8-45.8 12.1-70.6 12.1-20.9 0-41-3.1-60.1-8.7zM442.7 153.9c16.6 30.3 26 65.1 26 102.1 0 78.5-42.5 147-105.8 183.9l65-187.9c12.2-30.4 16.2-54.6 16.2-76.2 0-7.9-0.5-15.1-1.4-21.9zM504 256c0 136.8-111.3 248-248 248-136.8 0-248-111.3-248-248 0-136.8 111.2-248 248-248 136.7 0 248 111.2 248 248zM492.6 256c0-130.5-106.2-236.6-236.6-236.6-130.5 0-236.6 106.1-236.6 236.6s106.2 236.6 236.6 236.6c130.5 0 236.6-106.1 236.6-236.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wordpress.js
// module id = 1100
// module chunks = 0